export const NAME = 'requestCallback';

export const actionTypes = {
    SEND_BROKER_ACTION: `${NAME}/SEND_BROKER_ACTION`,
    SEND_EMAIL_QUOTE: `${NAME}/SEND_EMAIL_QUOTE`,
    RESET: `${NAME}/RESET`,
    UPDATE_CURRENT_PRODUCT: `${NAME}/UPDATE_CURRENT_PRODUCT`,
};
